import { Component } from '@angular/core';

@Component({
  selector: 'app-fabric-categories',
  templateUrl: './fabric-categories.component.html',
  styleUrl: './fabric-categories.component.scss',
})
export class FabricCategoriesComponent {}
